import React , { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import cssClasses from "./Loading.module.css";
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
const dialogStyle = {
  "& .MuiDialog-container":{
    background: "rgba(193, 201, 210, 0.7)"
  }
}


function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h6"
          component="div"
          color="#080808"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
export default function Loading() {

  const isLoading = useSelector((state) => state.IsLoading.isLoading);
  const [progress, setProgress] = React.useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);
   
  return (
		<Dialog 
      sx={[dialogStyle]} 
      open={isLoading}
    >
			<div className={cssClasses.wrapper}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CircularProgressWithLabel value={progress} />
          <p style={{margin: '0',fontSize: '2rem', marginLeft:"1rem" }}>Loading...</p>
        </Box>
			</div>
		</Dialog>
	);
}




